import { LoadingIcon } from "./style"
import { SpinningCircles } from 'react-loading-icons'
const Index = () => {
    return <LoadingIcon>
        <SpinningCircles fill="#fff"/>
    </LoadingIcon>
}

export default Index